// Мета-теги страницы: заголовок, описание, canonical, OpenGraph, Twitter, JSON-LD.
// Обновляются при каждом переходе. Страницы с данными из API (услуга, ресторан, галерея, номер) уточняют их через setPageSeo.
import { siteInfo } from '../config/sites'
import { pageMeta, headTags, hotelJsonLd, publicPath, siteKey, COPY } from './core.mjs'

// Amari живёт на своём домене без префикса /amari/ (сборка с VUE_APP_SITE=amari)
export const AMARI_MODE = process.env.VUE_APP_SITE === 'amari'
// Тестовый сайт (beta) закрыт от индексации: VUE_APP_NOINDEX=1
export const NOINDEX_ALL = process.env.VUE_APP_NOINDEX === '1'
export const ORIGIN = (process.env.VUE_APP_SITE_URL || (AMARI_MODE ? 'https://amarihotel.ru' : 'https://abaata.ru')).replace(/\/+$/, '')

let state = { site: null, route: null, page: {} }

const SITE_PREFIX = /^\/(abaata|pitsunda|picunda|amari)(?=\/|$)/

/** Путь страницы без префикса отеля: /abaata/offers/3 → /offers/3 */
export const relativePath = (route) => (route.path || '/').replace(SITE_PREFIX, '') || '/'

function render () {
  const { site, route, page } = state
  if (!route) return
  const select = route.name === 'selectSite'
  const key = select ? 'select' : siteKey(site) || 'abaata'
  const meta = pageMeta({ site: key, select, page: { ...page, routeName: route.name } })
  const path = select ? '/' : publicPath(key, relativePath(route), AMARI_MODE)

  let ldjson = null
  if (!select && (meta.home || route.name === 'contacts')) {
    const info = siteInfo(key)
    ldjson = hotelJsonLd({
      site: key, info, origin: ORIGIN, url: ORIGIN + publicPath(key, '/', AMARI_MODE),
      image: ORIGIN + '/og/' + key + '.jpg', description: COPY[key].description, name: key === 'amari' ? 'Amari Hotel' : 'Отель Абаата, ' + info.place
    })
  }

  const tags = headTags({
    origin: ORIGIN, path, meta, siteName: COPY[key].label, defaultImage: '/og/' + key + '.jpg', noindexAll: NOINDEX_ALL, ldjson
  })

  document.querySelectorAll('head [data-seo]').forEach((el) => el.parentNode.removeChild(el))
  tags.forEach(({ tag, attrs, text }) => {
    const el = document.createElement(tag)
    Object.keys(attrs).forEach((k) => el.setAttribute(k, attrs[k]))
    if (text) el.textContent = text
    document.head.appendChild(el)
  })
}

/** Вызывается при каждом переходе: сбрасывает данные прошлой страницы */
export function applySeo (site, route) {
  state = { site, route, page: {} }
  render()
}

/** Страница с данными из API уточняет заголовок: setPageSeo({ name, description, image }) */
export function setPageSeo (page) {
  state.page = { ...state.page, ...page }
  render()
}
